import React from "react";

export default function MachineSpecs({ machine }) {
  const specs = machine.spec;
  return (
    <div className="spec-wrapper">
      {specs.map((spec) => (
        <div className="detail" key={spec.id}>
          <span className="label">{spec.spec_label.slice(0, -1)}: </span>
          <span className="data">{spec.spec_description}</span>
        </div>
      ))}
    </div>
  );
}
